<div class="payment-methods-image-container">
  <img class="img-oxxo" src="{{ srcImage }}" alt="payment-method-image" *ngIf="srcImage.includes('cash_payment')" />
  <img [ngClass]="isSmall ? 'img-small' : 'img-large'" src="{{ srcImage }}" alt="payment-method-image" *ngIf="(srcImage.includes('paypal')) && paymentTypeCredit !== paymentTypeInfo.credit && !isBBVAPayment()
    " />
  <img [ngClass]="isSmall ? 'img-normal-small' : isBig ? 'img-big' : 'img-normal'" src="{{ srcImage }}"
    alt="payment-method-image"
    *ngIf="(!srcImage.includes('cash_payment') && !srcImage.includes('paypal')) && paymentTypeCredit !== paymentTypeInfo.credit && !isBBVAPayment()" />

  <img class="default-bbva"
    [ngClass]="{'img-bbva-small': isSmall, 'img-bbva': isBig, 'short-bbva-image':srcImage.includes('TDX')}"
    [src]="srcImage" alt="payment-method-image" *ngIf="isBBVAPayment()">

  <div *ngIf="paymentTypeCredit === paymentTypeInfo.credit" class="credit-payment">
    <div [ngClass]="isSmall ? 'img-normal-small' : 'img-normal'">
      <img src="{{ srcImage }}" alt="credit_omicron_lab" />
    </div>
    <div class="text-size-1 color-black">Compra a crédito</div>
  </div>
</div>